export type * from './types';
export * from './fixtures';
export * from './logic';

import {
  APPROVALS, BACKUPS, CHANGE_LOG, DELEGATIONS, DONE_TASKS, ESCALATIONS, LOGIN_LOG, NOTIFY_PREFS, SESSIONS, SETTINGS_SEATS, TASKS, TEAM,
} from './fixtures';

/** Nạp dữ liệu mẫu Việc & Duyệt + Cài đặt (A gắn vào `fixtures` của Hub). */
export function registerAdminFixtures(register: (entity: string, rows: readonly unknown[]) => void): void {
  register('adminTask', TASKS);
  register('adminDone', DONE_TASKS);
  register('adminApproval', APPROVALS);
  register('adminDelegation', DELEGATIONS);
  register('adminTeam', TEAM);
  register('adminEscalation', ESCALATIONS);
  register('adminSeat', SETTINGS_SEATS);
  register('adminNotify', NOTIFY_PREFS);
  register('adminBackup', BACKUPS);
  register('adminLoginLog', LOGIN_LOG);
  register('adminChangeLog', CHANGE_LOG);
  register('adminSession', SESSIONS);
}
